import { render, staticRenderFns } from "./ProjPools.vue?vue&type=template&id=136a9fed&scoped=true"
import script from "./ProjPools.vue?vue&type=script&lang=js"
export * from "./ProjPools.vue?vue&type=script&lang=js"
import style0 from "./ProjPools.vue?vue&type=style&index=0&id=136a9fed&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "136a9fed",
  null
  
)

export default component.exports